import React from 'react'

export default function Title({title}) {
  return (
    <div className='sectionTitle'>
      <h4>{title}</h4>  
    <div />
    </div>
  )
}
